// src/pages/GestaoEstabelecimentoMobile.jsx
import React, { useContext, useEffect, useRef } from 'react';
import { MdOutlineAttachMoney, MdPendingActions, MdWarning, MdPerson } from "react-icons/md";
import Chart from 'chart.js/auto';

import { ProdutosContext } from '../../../shared/contexts/ProdutosContext';
import { ItensPedidosContext } from '../../../shared/contexts/ItensPedidosContext';
import PedidosContext from '../../../shared/contexts/PedidosContext';
import { ClientesContext } from '../../../shared/contexts/ClientesContext';
import FooterOpcoes from '../../cliente/components/FooterOpcoes';

import styles from './GestaoEstabelecimentoMobile.module.css';

function GestaoEstabelecimentoMobile() {
  const idEstabelecimentoAtual = localStorage.getItem('estabelecimento_id');
  const nomeAdmin = localStorage.getItem('nomeAdmin') || "Admin";

  const { pedidos } = useContext(PedidosContext);
  const { clientes } = useContext(ClientesContext);

  const pedidosFiltrados = pedidos.filter(p => p.id_estabelecimento === Number(idEstabelecimentoAtual));
  const somaPrecos = pedidosFiltrados.filter(p => p.status === 'entregue' && !p.is_teste).reduce((total, p) => total + Number(p.total || 0), 0);

  const pedidosRef = useRef(null);
  const faturamentoRef = useRef(null);
  const chartInstances = useRef({});

  useEffect(() => {
    if (!pedidosFiltrados.length) return;

    // --- Pedidos por Hora ---
    const pedidosPorHora = {};
    pedidosFiltrados.forEach(p => {
      if (!p.data_pedido) return;
      const hora = new Date(p.data_pedido).getHours();
      pedidosPorHora[hora] = (pedidosPorHora[hora] || 0) + 1;
    });

    const labelsHora = Object.keys(pedidosPorHora).sort((a, b) => a - b).map(h => `${h}h`);
    const dataHora = Object.values(pedidosPorHora);

    if (pedidosRef.current) {
      if (chartInstances.current.pedidos) chartInstances.current.pedidos.destroy();
      chartInstances.current.pedidos = new Chart(pedidosRef.current.getContext('2d'), {
        type: 'line',
        data: {
          labels: labelsHora,
          datasets: [{
            label: "Pedidos por Hora",
            data: dataHora,
            borderColor: '#d33333',
            backgroundColor: 'transparent',
            tension: 0.3,
            borderWidth: 3
          }]
        },
        options: {
          responsive: true,
          plugins: { legend: { display: false } },
          scales: { y: { beginAtZero: true, stepSize: 1 } }
        }
      });
    }

    // --- Faturamento Diário (apenas pedidos entregues) ---
    const faturamentoDiario = {};
    pedidosFiltrados.filter(p => p.status === 'entregue' && !p.is_teste).forEach(p => {
      if (!p.data_pedido) return;
      const dia = new Date(p.data_pedido).toLocaleDateString('pt-BR');
      faturamentoDiario[dia] = (faturamentoDiario[dia] || 0) + Number(p.total || 0);
    });

    if (faturamentoRef.current) {
      if (chartInstances.current.faturamento) chartInstances.current.faturamento.destroy();
      chartInstances.current.faturamento = new Chart(faturamentoRef.current.getContext('2d'), {
        type: 'bar',
        data: {
          labels: Object.keys(faturamentoDiario),
          datasets: [{
            label: "Faturamento Diário (R$)",
            data: Object.values(faturamentoDiario),
            backgroundColor: '#ff8c42'
          }]
        },
        options: { responsive: true, plugins: { legend: { display: false } } }
      });
    }

  }, [pedidosFiltrados]);

  return (
    <div className={styles.containerMobile}>
      <header className={styles.header}>
        <h1>📊 Dashboard</h1>
        <p>Bem-vindo, {nomeAdmin}. Veja o resumo do seu estabelecimento.</p>
      </header>

      {/* Cards de Resumo */}
      <section className={styles.resumo}>
        <div className={`${styles.card} ${styles.cardGreen}`}>
          <MdOutlineAttachMoney className={styles.icon} />
          <p>R$ {somaPrecos.toFixed(2)}</p>
          <span>Faturamento</span>
        </div>

        <div className={`${styles.card} ${styles.cardRed}`}>
          <MdPendingActions className={styles.icon} />
          <p>{pedidosFiltrados.filter(p => p.status === "pendente").length}</p>
          <span>Pedidos Pendentes</span>
        </div>

        <div className={`${styles.card} ${styles.cardYellow}`}>
          <MdWarning className={styles.icon} />
          <p>2</p>
          <span>Estoque Crítico</span>
        </div>

        <div className={`${styles.card} ${styles.cardBlue}`}>
          <MdPerson className={styles.icon} />
          <p>{clientes.filter(c => c.id_estabelecimento === Number(idEstabelecimentoAtual)).length}</p>
          <span>Clientes</span>
        </div>
      </section>

      {/* Gráficos */}
      <section className={styles.graficos}>
        <div className={styles.cardGrafico}>
          <h3>Pedidos por Hora</h3>
          <p className={styles.desc}>Descubra em quais horários há mais movimento.</p>
          {pedidosFiltrados.length > 0 && <canvas ref={pedidosRef} className={styles.line_chart}></canvas>}
        </div>
      </section>

      <FooterOpcoes typeView="admin" />
    </div>
  );
}

export default GestaoEstabelecimentoMobile;
